<template>
		<modal :withOkBtn="true" :withCancelBtn="true" @close="$emit('close')" @ok="sameAsStep">
			<div slot="header">Same as step...</div>
			<div slot="body">
				<div class="form-group">
					<div class="form-label">Select a step:</div>
					<select-box :options="scene.nodes" :placeholder="'Select step'" @change="updateSelectedStep" 
						:inputError="attemptSubmit && isChosenStepEmpty"></select-box>
					<div class="modal-message" v-if="attemptSubmit && isChosenStepEmpty">Please choose a step from the list</div>
				</div>
			</div>
		</modal>
</template>

<script>
	import Modal from './Modal'
	import SelectBox from '@/components/SelectBox'
	import {mapGetters} from 'vuex'

	export default {
		name: 'SameStepModal',
		components: {
			'modal': Modal,
			'selectBox': SelectBox
		},
		computed: {
			...mapGetters(['scene']),
			isChosenStepEmpty: function() {
				return this.chosenStep === '';
			}
		},
		data() {
			return {
				message: '',
				chosenStep: '',
				attemptSubmit: false
			}
		},
		methods: {
			sameAsStep() {
				this.attemptSubmit = true;
				if (!this.isChosenStepEmpty) {
					this.$emit('ok', this.chosenStep);
				}
			},
			updateSelectedStep(index) {
				this.chosenStep = index;
			}
		}
	}
</script>
